import * as Sentry from "@sentry/react";
import posthog from "posthog-js";
import {
  ANONYMOUS_APPEAL_STORAGE_KEY,
  LAST_ACTIVITY_AT_STORAGE_KEY,
} from "../constants/sign-out-storage-keys";

type ClearableApolloClient = {
  clearStore: () => Promise<unknown>;
};

type PerformSignOutDeps = {
  amplifySignOut: () => Promise<void>;
  apolloClient: ClearableApolloClient;
  redirectUrl: string;
};

export async function performSignOut({
  amplifySignOut,
  apolloClient,
  redirectUrl,
}: PerformSignOutDeps): Promise<void> {
  posthog.reset();

  try {
    await apolloClient.clearStore();
  } catch (error) {
    Sentry.captureException(error);
  }

  try {
    await amplifySignOut();
  } catch (error) {
    Sentry.captureException(error);
  }

  sessionStorage.removeItem(ANONYMOUS_APPEAL_STORAGE_KEY);
  localStorage.removeItem(LAST_ACTIVITY_AT_STORAGE_KEY);

  window.location.assign(redirectUrl);
}
